import { styled } from '@mui/material/styles';
import { Switch } from '@mui/material';

export const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: '68px',
  height: '38px',
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      transform: 'translateX(31px) !important',
    },
  },
  '& .MuiSwitch-thumb': {
    width: '20px',
    height: '20px',
  },
  '& .MuiSwitch-track': {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.slider.mediaPlan.track,
  },
}));
